module.exports = __webpack_public_path__ + "img/75.8af03360.jpg";